import React from 'react';
import PropTypes from 'prop-types';

export default class Detail extends React.Component {
  render() {
    const {name, value} = this.props.detail;

    return (
      <li className="details__list-item">
        <div className="details__name">{name}</div>
        <div className="details__value">{value}</div>
      </li>
    );
  }
}

Detail.propTypes = {
  detail: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Details/Detail.js